





import Vue, {VueConstructor} from 'vue'
import {USER_ROLE_STUDAUTH, CONF_BASE_URL, CONF_HIDE_EXPORT_USERS} from '@/constants'
import config from '@/config.ts'

export default Vue.extend({
  name: 'studPassBtn',
  props: {
    scope: {} as () => {filtersData: {}}
  },
  methods: {
    async onButtonClick () {
      try {
        var windowReference = window.open();
        let params = this.scope.filtersData
        let res = await this.$store.dispatch('students/passwords', {query: {...params}})
        if (res.count < 20000) {
          // @ts-ignore
          windowReference.location = config(CONF_BASE_URL) + res.url;
        } else {
          // @ts-ignore
          this.$message.warning(this.$t('labels.can_pick_max_20000_users'))
        }
        /* if (Object.keys(params).length) {
        } else {
          this.$message.warning('Выберите фильтры или обучающихся')
        } */
      } catch (error) {
        console.error('LOG: onButtonClick -> error', error)
        // @ts-ignore
        this.$message.error(this.$t('labels.can_not_download_data'))
      }
    }
  },
  computed: {
    admin (): boolean {
      if (this.$store.state.user.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_STUDAUTH)
      }

      return false
    },
    isVisibleDownloadButton() {
      // @ts-ignore
      return this.admin && !config(CONF_HIDE_EXPORT_USERS);
    }
  }
})
